import {SelectInput} from 'exsportia-components'
import {useFormikContext} from 'formik'
import {FC, useCallback} from 'react'

import {SubscriptionFormType} from '../../../services/subscription/forms/subscription-purchase-form'
import {CycleOption} from '../helpers'

type Props = {
  installmentsOptions: CycleOption['installmentsOptions']
}

export const InstallmentsOptions: FC<Props> = ({installmentsOptions}) => {
  const {setFieldValue, values} = useFormikContext<SubscriptionFormType>()
  // eslint-disable-next-line
  const setInstallmentOption = useCallback((value: any) => { // TODO: select input types unsafe
    setFieldValue('installmentOption', value).catch(e => console.log(String(e)))
  }, [installmentsOptions])

  return (
    <SelectInput
      name='installmentOption'
      isSearchable={false}
      options={installmentsOptions}
      onChange={setInstallmentOption}
      value={values.installmentOption}
      settings={{
        // eslint-disable-next-line
        container: (provide: any) => ({
          ...provide,
          width: '100%',
        }),
      }} />
  )
}